<template>
  <div>
    <div class="bg-gray-900 p-2 -mt-2">
      <span class="text-gray-300 text-sm">{{ $t('Not me:') }} </span>
      <transition-group name="list-complete">
        <div
          v-for="(card, index) in notmearray"
          :key="card.id"
          class="notcard"
        >
                <input type="hidden" id="MaybeMe">
                <button class="comparebutton"  @click="CompareItem(index, card)">{{ card.attributes['title'].text }}</button>
        </div>
      </transition-group>
    </div>
    <div class="comparison-wrapper">
        <transition-group name="list-reverse" class="comparison-responsive flex-row" tag="div">
          <div
            v-for="(card, index) in cards"
            :key="card.id"
            class="comparison-item text-center flex-col"
          >
                <div v-if="index === 0" class="attributes">
                  <button v-if="cards.length > 2" class="maybemebutton" @click="MaybeMeOne(index, cards[1])"><i aria-hidden="true" class="material-icons align-middle">check</i>{{ $t('More Me') }}</button>
                  <button v-if="cards.length > 2" class="notmebutton" @click="NotMe(index, card)"><i aria-hidden="true" class="material-icons align-middle">close</i>{{ $t('Less Me') }}</button>
                    <template v-if="cards.length < 3">
                      <template v-if="demo !== ('1')">
                        <button id="submitFinal" class="btn btn-sm bg-yellow-600 hover:bg-yellow-800 pr-0" @click="submitFinal(card.id)">{{ $t('Final Choice') }} <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
                      </template>
                      <template v-else>
                        <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">{{ $t('Restart Demo') }}<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
                      </template>
                    </template>
                    <div class="cell" v-for="attributes in card.attributes">
                      <span class="label">{{ attributes.label }}</span>
                      <span class="description" v-html="attributes.text"></span>
                    </div>
                </div>
                <div v-if="index === 1" class="attributes">
                  <button v-if="cards.length > 2" class="maybemebutton" @click="MaybeMeTwo(index, cards[0])"><i aria-hidden="true" class="material-icons align-middle">check</i>{{ $t('More Me') }}</button>
                  <button v-if="cards.length > 2" class="notmebutton" @click="NotMe(index, card)"><i aria-hidden="true" class="material-icons align-middle">close</i>{{ $t('Less Me') }}</button>
                    <template v-if="cards.length < 3">
                      <template v-if="demo !== ('1')">
                        <button id="submitFinal2" class="btn btn-sm bg-yellow-600 hover:bg-yellow-800 pr-0" @click="submitFinal(card.id)">{{ $t('Final Choice') }} <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
                      </template>
                      <template v-else>
                        <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">{{ $t('Restart Demo') }}<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
                      </template>
                    </template>
                    <div class="cell" v-for="attributes in card.attributes">
                      <span class="label">{{ attributes.label }}</span>
                      <span class="description" v-html="attributes.text"></span>
                    </div>
                </div>
          </div>
        </transition-group>
    </div>
    <div class="whitespace-no-wrap text-center">
      <div
          v-for="card in cards"
          :key="card.id"
          class="comparison-dots text-center inline-block text-xl text-gray-500"
        >
          .
      </div>
    </div> 
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
      array: '',
      notarray: '',
      merged: [],
      route:'',
      demo:'',
  },
  data () {
    return {
      cards: this.array,
      notmearray: this.notarray,
    }
  },
  methods: {
    restartActivity() {
      $( ".submitResults").addClass( "loading" );
      location.reload();
    },
    CompareItem(index, card){
        this.cards.unshift(card);
        this.notmearray.splice(index, 1);
        console.log('Moved to Maybe Me');
    },
    MaybeMeOne(index, oppositecard){
        this.cards.splice(index + 1, 1);
        this.notmearray.unshift(oppositecard);
        console.log('Moved Opposite to Less Me');
    },
    MaybeMeTwo(index, oppositecard){
        this.cards.splice(index - 1, 1);
        this.notmearray.unshift(oppositecard);
        console.log('Moved Opposite to Less Me');
    },
    NotMe(index, card){
        this.notmearray.unshift(card);
        this.cards.splice(index, 1);
        console.log('Moved to Less Me');
    },
    submitFinal(id) {
        $( "#submitFinal").addClass( "loading" );
        $( "#submitFinal2").addClass( "loading" );
        axios.put(this.route, { 
          results: [id] 
        }).then(function (response) {
            console.log(response);
          }).then(function (event) {
            location.reload();
          })
      },
  }
};
</script>
